import { IconCoin, IconCreditCard, IconVelocimeter, IconId, IconUser, IconHelpCircle, IconLock } from '@consumidor-positivo/aurora';
import isDesktop from '@libs/utils/helpers/isDesktop';
import { useLocation } from 'react-router-dom';
import { useRedline } from '@libs/redline';
import { getHomePath } from '@libs/renegkit/experiments/RKOffersListing';

export const usePrivatePagesStates = () => {
  const location = useLocation();
  const { track: trackRedline } = useRedline();
  // dx-rk-offers-listing: debts entry points to /inicio for the variant.
  const homePath = getHomePath();

  const handleNavigate = (path: string, title: string) => {
    trackRedline.userTracking.elementClicked({
      elementType: 'button/text',
      location: location.pathname,
      position: 'navbar',
      name: path,
      text: title,
    });

    if (path === '/ajuda') {
      window.open('https://www.consumidorpositivo.com.br/central-de-ajuda');
      return;
    }

    window.location.href = path;
  };

  const dataSourceNavbar = [
    {
      name: 'Dívidas',
      dropdown: [
        {
          name: 'Dívidas para negociar',
          onClick: () => handleNavigate(homePath, 'Dívidas para negociar'),
          active: location.pathname === homePath,
        },
        {
          name: 'Meus acordos',
          onClick: () => handleNavigate('/meus-acordos', 'Meus acordos'),
          active: location.pathname === '/meus-acordos',
        },
        {
          name: 'Dívidas negativadas',
          onClick: () => handleNavigate('/debitos-negativados', 'Dívidas negativadas'),
          active: location.pathname === '/debitos-negativados',
        },
      ],
    },
    {
      name: 'Crédito',
      dropdown: [
        {
          name: 'Minhas ofertas',
          onClick: () => handleNavigate('/minhas-ofertas', 'Minhas ofertas'),
          active: location.pathname === '/minhas-ofertas',
        },
        {
          name: 'Todas ofertas',
          onClick: () => handleNavigate('/ofertas', 'Todas ofertas'),
          active: location.pathname === '/ofertas',
        },
        {
          name: 'Match Positivo',
          onClick: () => handleNavigate('/comparador', 'Match Positivo'),
          active: location.pathname === '/comparador',
        },
      ],
    },
    {
      name: 'Score',
      dropdown: [
        {
          name: 'Minha pontuação',
          onClick: () => handleNavigate('/meu-score', 'Minha pontuação'),
          active: location.pathname === '/meu-score',
        },
        {
          name: 'Aumentar meu Score',
          onClick: () => handleNavigate('/meus-objetivos', 'Aumentar meu Score'),
          active: location.pathname === '/meus-objetivos',
        },
        {
          name: 'Histórico de Score',
          onClick: () => handleNavigate('/meus-objetivos/historico', 'Histórico de Score'),
          active: location.pathname === '/meus-objetivos/historico',
        },
      ],
    },
    {
      name: 'Meu CPF',
      dropdown: [
        {
          name: 'Alerta CPF',
          onClick: () => handleNavigate('/alerta-cpf', 'Alerta CPF'),
          active: location.pathname === '/alerta-cpf',
        },
        {
          name: 'Consultas em meu CPF',
          onClick: () => handleNavigate('/consultas-cpf', 'Consultas em meu CPF'),
          active: location.pathname === '/consultas-cpf',
        },
        {
          name: 'Cadastro positivo',
          onClick: () => handleNavigate('/contas-pagamentos', 'Cadastro positivo'),
          active: location.pathname === '/contas-pagamentos',
        },
      ],
    },
    {
      name: 'Central de ajuda',
      onClick: () => handleNavigate('/ajuda', 'Central de ajuda'),
      active: false,
    },
  ];

  const itemNameDesktop = ['Minha conta', 'Alterar senha'];

  const dataSourceNavbarVertical = [
    {
      name: 'Dívidas',
      Icon: <IconCoin />,
      dropdown: [
        {
          name: 'Dívidas para negociar',
          onClick: () => handleNavigate(homePath, 'Dívidas para negociar'),
          active: location.pathname === homePath,
        },
        {
          name: 'Meus acordos',
          onClick: () => handleNavigate('/meus-acordos', 'Meus acordos'),
          active: location.pathname === '/meus-acordos',
        },
        {
          name: 'Dívidas negativadas',
          onClick: () => handleNavigate('/debitos-negativados', 'Dívidas negativadas'),
          active: location.pathname === '/debitos-negativados',
        },
      ],
    },
    {
      name: 'Crédito',
      Icon: <IconCreditCard />,
      dropdown: [
        {
          name: 'Minhas ofertas',
          onClick: () => handleNavigate('/minhas-ofertas', 'Minhas ofertas'),
          active: location.pathname === '/minhas-ofertas',
        },
        {
          name: 'Todas ofertas',
          onClick: () => handleNavigate('/ofertas', 'Todas ofertas'),
          active: location.pathname === '/ofertas',
        },
        {
          name: 'Match Positivo',
          onClick: () => handleNavigate('/comparador', 'Match Positivo'),
          active: location.pathname === '/comparador',
        },
      ],
    },
    {
      name: 'Score',
      Icon: <IconVelocimeter />,
      dropdown: [
        {
          name: 'Minha pontuação',
          onClick: () => handleNavigate('/meu-score', 'Minha pontuação'),
          active: location.pathname === '/meu-score',
        },
        {
          name: 'Aumentar meu Score',
          onClick: () => handleNavigate('/meus-objetivos', 'Aumentar meu Score'),
          active: location.pathname === '/meus-objetivos',
        },
        {
          name: 'Histórico de Score',
          onClick: () => handleNavigate('/meus-objetivos/historico', 'Histórico de Score'),
          active: location.pathname === '/meus-objetivos/historico',
        },
      ],
    },
    {
      name: 'Meu CPF',
      Icon: <IconId />,
      dropdown: [
        {
          name: 'Alerta CPF',
          onClick: () => handleNavigate('/alerta-cpf', 'Alerta CPF'),
          active: location.pathname === '/alerta-cpf',
        },
        {
          name: 'Consultas em meu CPF',
          onClick: () => handleNavigate('/consultas-cpf', 'Consultas em meu CPF'),
          active: location.pathname === '/consultas-cpf',
        },
        {
          name: 'Cadastro positivo',
          onClick: () => handleNavigate('/contas-pagamentos', 'Cadastro positivo'),
          active: location.pathname === '/contas-pagamentos',
        },
      ],
    },
    {
      name: 'Minha conta',
      Icon: <IconUser />,
      onClick: () => handleNavigate('/minha-conta', 'Minha conta'),
      active: location.pathname === '/minha-conta',
    },
    {
      name: 'Alterar senha',
      Icon: <IconLock />,
      onClick: () => handleNavigate('/alterar-senha', 'Alterar senha'),
      active: location.pathname === '/alterar-senha',
    },
    {
      name: 'Central de ajuda',
      Icon: <IconHelpCircle />,
      onClick: () => handleNavigate('/ajuda', 'Central de ajuda'),
      active: false,
    },
  ].filter((item) => (isDesktop() ? itemNameDesktop.includes(item.name) : item));

  return {
    dataSourceNavbar,
    dataSourceNavbarVertical,
  };
};
